import React from "react";

const UnderMaintenancePage = () => {
  return (
    <div className="h-screen w-screen flex items-center justify-center bg-gray-100 px-4 text-center mt-5">
  <div className="flex flex-col items-center justify-center">
    <h1 className="text-5xl font-bold text-yellow-600 mb-4">
      🚧 Under Maintenance
    </h1>
    <p className="text-lg text-gray-700 mb-6">
      We’re currently working on something awesome.<br />
      Please check back later.
    </p>
    <div className="text-sm text-gray-500">
      &copy; {new Date().getFullYear()} Shreenath Energy
    </div>
  </div>
</div>

  );
};

export default UnderMaintenancePage;
